import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import * as _ from 'lodash';

import { UrlQueryService } from '../../core/services/url-query.service';
import { PosthogService } from '../../core/services/posthog.service';

import { ISite } from '../../types/datatypes';

@Component({
	selector: 'app-promo-stacks-filters',
	templateUrl: './promo-stacks-filters.component.html',
	styleUrls: ['./promo-stacks-filters.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class PromoStackFiltersComponent {
	@Input()
	set genres(genres) {
		if (genres.length === 0) return;
		this._genres = genres;
		this.loadMoreGenres();
	}

	@Input() sites: ISite[];

	@Input() durations: string[];

	@Input() set openFilters(status) {
		if (status === this._openFilters) {
			return;
		}
		this._openFilters = status;

		if (status === false) {
			this.applyFilters();
		}
	}

	@Input() set loaded(loading: boolean) {
		if (loading) return;

		this.handleQueryParams();
	}

	@Output() selectedGenresList = new EventEmitter();

	@Output() selectedPrice = new EventEmitter();

	@Output() selectedDuration = new EventEmitter();

	@Output() selectedSite = new EventEmitter();

	@Output() closeDrawer = new EventEmitter();

	public _openFilters = false;

	public _genres: string[];

	public displayedGenres: string[];

	public genresToShow = 99;

	public sitesToShow = 0;

	public selectedItem: string;

	public displayGenreList = false;

	public allowClickOutside = false;

	public selectedGenres = [];

	public bookPrices = ['All', 'Free', '$.99', '$1.99', '$2.99', '$3.00+'];

	public selectedBookPrice = ['All'];

	public _selectedDuration = ['All'];

	public _selectedSite = ['All'];

	public loading = false;

	get activeFilters() {
		let count = 0;
		if (!this.selectedGenres.includes('All') && this.selectedGenres.length > 0) count += 1;
		if (!this._selectedDuration.includes('All') && this._selectedDuration.length > 0) count += 1;
		if (!this._selectedSite.includes('All') && this._selectedSite.length > 0) count += 1;
		if (!this.selectedBookPrice.includes('All') && this.selectedBookPrice.length > 0) count += 1;

		return count;
	}

	constructor(
		private urlQueryService: UrlQueryService,
		private posthogService: PosthogService,
	) {
		const [bookPrice] = this.bookPrices;
		this.selectedBookPrice = [bookPrice];
	}

	@Input() set defaults(defaultValues: { genre: string[]; duration: string[]; price: string[]; site: string[] }) {
		this.selectedGenres = defaultValues.genre;
	}

	toggleGenereList() {
		this.allowClickOutside = false;
		this.displayGenreList = !this.displayGenreList;

		if (this.displayGenreList) {
			setTimeout(() => {
				this.allowClickOutside = true;
			}, 200);
		}
	}

	loadMoreGenres() {
		this.genresToShow += 5;
		this.loadGenres();
	}

	loadGenres() {
		this.displayedGenres = this._genres.slice(0, this.genresToShow);
	}

	toggleGenre(event) {
		const checkbox = event.target as HTMLInputElement;
		const genre = checkbox.value;
		if (checkbox.checked) {
			if (genre === 'All') {
				this.removeAllGenres();
			}

			if (genre !== 'All' && this.selectedGenres.includes('All')) {
				this.removeAllGenre();
			}

			if (!this.selectedGenres.includes(genre)) {
				this.selectedGenres.push(genre);
			} else {
				const index = _.indexOf(this.selectedGenres, genre);
				this.selectedGenres.splice(index, 1);
			}
		} else {
			if (!this.selectedGenres.includes(genre)) return;

			const index = _.indexOf(this.selectedGenres, genre);
			this.selectedGenres.splice(index, 1);
		}
	}

	removeAllGenre() {
		const index = _.indexOf(this.selectedGenres, 'All');
		this.selectedGenres.splice(index, 1);
	}

	removeAllGenres() {
		this.selectedGenres = [];
	}

	clearSelectedGenres() {
		this.selectedGenres = [];
		this.displayGenreList = false;
		this.selectedGenresList.emit(this.selectedGenres);
	}

	handleQueryParams() {
		const query = this.urlQueryService.load();

		if (query.selectedGenre) {
			const selectedGenres = query.selectedGenre.split(',');
			this.selectedGenres = selectedGenres;
			this.selectedGenresList.emit(this.selectedGenres);
		}

		if (query.selectedDuration) {
			const selectedDuration = query.selectedDuration.split(',');
			this._selectedDuration = selectedDuration;
			this.selectedDuration.emit(this._selectedDuration);
		}

		if (query.selectedBookPrice) {
			const selectedBookPrice = query.selectedBookPrice.split(',');
			this.selectedBookPrice = selectedBookPrice;
			this.selectedPrice.emit(this.selectedBookPrice);
		}

		if (query.selectedSite) {
			const selectedSite = query.selectedSite.split(',');
			this._selectedSite = selectedSite;
			this.selectedSite.emit(this._selectedSite);
		}
	}

	setBookPrice(event) {
		const checkbox = event.target as HTMLInputElement;
		const bookPrice = checkbox.value;
		if (checkbox.checked) {
			if (bookPrice === 'All') {
				this.selectedBookPrice = [];
			}

			if (bookPrice !== 'All' && this.selectedBookPrice.includes('All')) {
				const index = _.indexOf(this.selectedBookPrice, 'All');
				this.selectedBookPrice.splice(index, 1);
			}

			if (!this.selectedBookPrice.includes(bookPrice)) {
				this.selectedBookPrice.push(bookPrice);
			} else {
				const index = _.indexOf(this.selectedBookPrice, bookPrice);
				this.selectedBookPrice.splice(index, 1);
			}

			return;
		}

		if (!this.selectedBookPrice.includes(bookPrice)) return;

		const index = _.indexOf(this.selectedBookPrice, bookPrice);
		this.selectedBookPrice.splice(index, 1);
	}

	setDuration(event: Event) {
		const checkbox = event.target as HTMLInputElement;
		const duration = checkbox.value;

		if (checkbox.checked) {
			if (duration === 'All') {
				this._selectedDuration = [];
			}

			if (duration !== 'All' && this._selectedDuration.includes('All')) {
				const index = _.indexOf(this._selectedDuration, 'All');
				this._selectedDuration.splice(index, 1);
			}

			if (!this._selectedDuration.includes(duration)) {
				this._selectedDuration.push(duration);
			} else {
				const index = _.indexOf(this._selectedDuration, duration);
				this._selectedDuration.splice(index, 1);
			}
		} else {
			if (!this._selectedDuration.includes(duration)) return;

			const index = _.indexOf(this._selectedDuration, duration);
			this._selectedDuration.splice(index, 1);
		}
	}

	setSite(event) {
		const checkbox = event.target as HTMLInputElement;
		const site = checkbox.value;

		if (checkbox.checked) {
			if (site === 'All') {
				this._selectedSite = [];
			}

			if (site !== 'All' && this._selectedSite.includes('All')) {
				const index = _.indexOf(this._selectedSite, 'All');
				this._selectedSite.splice(index, 1);
			}

			if (!this._selectedSite.includes(site)) {
				this._selectedSite.push(site);
			} else {
				const index = _.indexOf(this._selectedSite, site);
				this._selectedSite.splice(index, 1);
			}
		} else {
			if (!this._selectedSite.includes(site)) return;

			const index = _.indexOf(this._selectedSite, site);
			this._selectedSite.splice(index, 1);
		}
	}

	handleClickOutside() {
		if (!this.allowClickOutside) return;
		this.displayGenreList = false;
		this.allowClickOutside = false;
	}

	_closeDrawer() {
		this.closeDrawer.emit(false);
	}

	clearFilters() {
		this.selectedBookPrice = ['All'];
		this._selectedDuration = ['All'];
		this._selectedSite = ['All'];
		this.selectedGenres = ['All'];

		this.selectedPrice.emit(this.selectedBookPrice);
		this.selectedDuration.emit(this._selectedDuration);
		this.selectedSite.emit(this._selectedSite);
		this.selectedGenresList.emit(this.selectedGenres);
		this._closeDrawer();
	}

	applyFilters() {
		this.selectedPrice.emit(this.selectedBookPrice);
		this.selectedDuration.emit(this._selectedDuration);
		this.selectedSite.emit(this._selectedSite);
		this.selectedGenresList.emit(this.selectedGenres);

		this._closeDrawer();

		this.posthogService.capture(this.posthogService.PRODUCT_LIST_VIEWED, {
			product_type: 'promoStack',
			filters_applied: {
				price: this.selectedBookPrice,
				duration: this._selectedDuration,
				site: this._selectedSite,
				genres: this.selectedGenres,
			},
		});
	}
}
